import { mapGetters, mapMutations } from "vuex";
import { getProductPriceTitle, resolveProductImage, routeToProduct } from "@/helpers";
import saleRows from "@/mixins/sale-rows";

export default {
  name: "basket-item",
  // `priceType` used to be a prop passed down from the page; it now comes from
  // the mixin, which is also what supplies the row money.
  mixins: [saleRows],
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedCount: 1,
      width: window.innerWidth,
    };
  },
  computed: {
    ...mapGetters({
      user: "profile/user",
      isDistributor: "profile/isDistributor",
    }),
  },
  methods: {
    getProductPriceTitle,
    routeToProduct,
    resolveProductImage,
    ...mapMutations({
      increment: "basket/INCREMENT_BASKET_LIST_COUNT",
      decrement: "basket/DECREMENT_BASKET_LIST_COUNT",
      setCount: "basket/SET_BASKET_LIST_COUNT",
      remove: "basket/REMOVE_ITEM_FROM_BASKET",
    }),
    handleRemove(data) {
      this.remove(data);
      this.$emit("update-gift");
    },
    changeCount(type, count = 1) {
      if (type === "increment") {
        this.increment(this.product);
      } else if (type === "decrement") {
        this.decrement(this.product);
      } else {
        if (count) {
          this.setCount({
            product: this.product,
            select_count: parseInt(count),
          });
        }
      }
      this.$emit("update-gift");
    },
    updateWidth() {
      this.width = window.innerWidth;
    },
  },
  mounted() {
    window.addEventListener("resize", this.updateWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWidth);
  },
};
